import 'vuetify/dist/vuetify.min.css'
import Vue from 'vue'
import store from './store'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import VueTheMask from 'vue-the-mask'
import globalMixin from './mixins/global'
import i18n from './lang/index.js'

Vue.config.productionTip = false

Vue.use(Vuetify)
Vue.use(VueTheMask)
Vue.mixin(globalMixin)

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  render: h => h(App),
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js